module.exports = __webpack_public_path__ + "static/subset-UniNeueBlack-7415f0d55c03816debdd951c6f6dd4cf.woff2";